import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { LESSON_FEATURE_KEY } from './keys';
import { lessonReducer } from './reducers/lesson.reducer';
import { LessonEffects } from './effects/lesson.effects';

export function provideLessonStore(): EnvironmentProviders[] {
    return [provideState(LESSON_FEATURE_KEY, lessonReducer), provideEffects(LessonEffects)];
}
